export default __webpack_public_path__ + "static/media/checkbox.2e21f584.svg";